import React, { FunctionComponent } from 'react';
import { faVideo } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconVideo: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faVideo} />;

export { BrassIconVideo };
